var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gm',{ref:"gm",staticStyle:{"border-radius":"4px","overflow":"hidden"},attrs:{"geo":_vm.geo,"toggleNoDetects":_vm.geo.toggleNoDetects,"reset":_vm.reset,"height":_vm.height + 'px'},on:{"loading":function($event){return _vm.$emit('loading')},"loaded":function($event){return _vm.$emit('loaded')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }